// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statistics .shuaxinImg[data-v-cf5487f0]{cursor:pointer;margin-right:5px;width:12px;vertical-align:-1px;fill:#333}.statistics .shuaxinImg[data-v-cf5487f0]:active{fill:#006dcc}.statistics .title[data-v-cf5487f0]{font-size:12px;color:#333}.statistics img[data-v-cf5487f0]{position:relative;top:-1px}", ""]);
// Exports
module.exports = exports;
